<template>
  <div>
    <div class="panel panel-stretch panel-primary">
      <div class="panel-heading">
        Beschikbare Pakketten Overzicht
      </div>
      <div v-if="!customerSelected" class="panel-body">
        Selecteer een klant om de berichten te kunnen verwerken
      </div>
      <div v-else-if="hasPackages" class="panel-body no-padding">
        <p>
          Dit is een overzicht van de beschikbare pakketten en polissen van de klant. Verder naar beneden kunt u
          aangeven hoe u de berichten wilt koppelen.
        </p>
        <div v-for="packagePolicy in currentPackages" :key="packagePolicy.id">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Pakketnummer</th>
              <th>Status</th>
              <th>Pakket totaaldekking</th>
              <th>Pakketpremie</th>
              <th>Datum laatste mutatie</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ packagePolicy.contractNumber }}</td>
              <td>
                <policy-status-component :policy-id="packagePolicy.id"></policy-status-component>
              </td>
              <td>{{ packagePolicy.totalInsuredAmount }}</td>
              <td>{{ packagePolicy.totalPremium }}</td>
              <td>{{ packagePolicy.mutation_date }}</td>
            </tr>
            </tbody>
          </table>
          <div>
            <div v-if="packagePolicy.children.length > 0">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Contractnummer</th>
                  <th>Status</th>
                  <th>Labels</th>
                  <th>Verzekerde som</th>
                  <th>Premie</th>
                  <th>Looptijd</th>
                  <th>Mutatie datum</th>
                  <th>Maatschappij</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="policy in packagePolicy.children" :key="policy.id">
                  <td>{{ policy.contractNumber }}</td>
                  <td class="text-center">
                    <policy-status-component :policy-id="policy.id"></policy-status-component>
                  </td>
                  <td>
                    <policy-description-component :policy-id="policy.id"></policy-description-component>
                  </td>
                  <td>{{ policy.insuredAmount }}</td>
                  <td>{{ policy.premium }}</td>
                  <td>{{ policy.duration }}</td>
                  <td>{{ policy.mutation_date }}</td>
                  <td><p v-if="policy.agency">{{ policy.agency.name }}</p></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              Er zijn geen polissen in dit pakket
            </div>
          </div>
        </div>
      </div>
      <div v-else class="panel-body">
        <div>
          Deze klant heeft geen pakketten, kies voor de optie "nieuw pakket"
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters, mapActions} from 'vuex'
import store from '../../../store';
import siviModule from '../store'
import PolicyDescriptionComponent from "../../policy/components/PolicyDescriptionComponent";
import PolicyStatusComponent from "../../policy/components/PolicyStatusComponent";

export default {
  name: "ShowAvailablePoliciesComponent",
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('sivi', [
      'currentPackages',
      'selectedCustomerId'
    ]),
    hasPackages() {
      if (this.currentPackages) {
        return this.currentPackages.length > 0;
      }
      return false
    },
    customerSelected() {
      return this.selectedCustomerId !== false
    }
  },
  created() {
    if (!store.hasModule('sivi')) {
      store.registerModule('sivi', siviModule)
    }
  },
  mounted() {
  },
  components: {
    PolicyDescriptionComponent,
    PolicyStatusComponent
  },
  methods: {}
}
</script>

<style scoped>

table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>
